import {loadable} from 'router/routes';
import {
    Page,
    fetchCity,
    fetchDestination,
    foldWithSearchState,
    isMonthlyPage,
} from './utils';
import React from 'react';
import EventsAPI from 'api/events';
import isNil from 'lodash/isNil';

const SearchMobileDestination = loadable(() =>
    import('search/SearchMobileDestination')
);
const SearchMobileMonthly = loadable(() =>
    import('search/SearchMobileMonthly')
);
const SearchDesktopDestination = loadable(() =>
    import('search/SearchDesktopDestination')
);
const SearchDesktopMonthly = loadable(() =>
    import('search/SearchDesktopMonthly')
);

// eslint-disable-next-line react/prop-types
const Destination = ({configData: {isMobile}, isMonthly}) =>
    isMobile && isMonthly ? (
        <SearchMobileMonthly />
    ) : isMobile ? (
        <SearchMobileDestination />
    ) : isMonthly ? (
        <SearchDesktopMonthly />
    ) : (
        <SearchDesktopDestination />
    );

Destination.getInitialState = async ({
    state,
    params,
    query,
    cookies,
    route,
}) => {
    const citySlug = params.city;
    const city = await fetchCity(state, citySlug);
    const destination = await fetchDestination(params, state, citySlug);
    const isMonthly = isMonthlyPage(route);

    if (isMonthly) {
        query.monthly = isMonthly;
    }

    const {
        data: {timezone},
    } = city;

    const {
        data: {
            latitude,
            longitude,
            id: destinationId,
            has_upcoming_events: hasEvents,
        },
    } = destination;

    if (!isNil(query.eid)) {
        const {data: event} = await EventsAPI.getById(query.eid);

        return foldWithSearchState({
            state: {
                ...state,
                city,
                destination,
                event,
            },
            type: Page.EVENT,
            latitude,
            longitude,
            timezone,
            query: {
                ...query,
                starts: event.starts,
                ends: event.ends,
            },
            cookies,
        });
    }

    if (hasEvents) {
        destination.data.events = await EventsAPI.get({destinationId}).then(
            res => res.data.data.results
        );
    }

    return foldWithSearchState({
        state: {
            ...state,
            city,
            destination,
        },
        type: hasEvents ? 'venue' : Page.DESTINATION,
        latitude,
        longitude,
        timezone,
        query,
        cookies,
    });
};

export default Destination;
